module.exports = __webpack_public_path__ + "static/media/V2.0fe6b6cc.png";